var React = require('react');

function TimelapsePause (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 19h4V5H6v14zm8-14v14h4V5h-4z"}));
}

TimelapsePause.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = TimelapsePause;

TimelapsePause.default = TimelapsePause;
